export const ArchiveWallContainerClass = "article-view__piano-metering";
// This is for providing position from template builder to inject the meter paywall
export const PianoMeteringContainerClass = "piano-metering__paywall-container";
